/* MODEZA — interactions. Vanilla JS, no dependencies, theme-editor aware. */
(function () {
  if (window.__modeza) return;
  window.__modeza = true;
  document.documentElement.classList.add('mz-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Scroll reveal ---------- */
  var io = null;
  function reveal(root) {
    var els = $$('[data-mz-reveal]:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || reduce || designMode) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    io = io || new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Count-up numbers ("10K+", "4.9") ---------- */
  function countUp(root) {
    $$('[data-mz-count]:not([data-done])', root).forEach(function (el) {
      el.setAttribute('data-done', '');
      var raw = el.textContent.trim(), m = raw.match(/^(\D*)([\d.,]+)(.*)$/);
      if (!m || reduce || designMode) return;
      var target = parseFloat(m[2].replace(/,/g, '')), dec = (m[2].split('.')[1] || '').length, t0 = null, dur = 1600;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 4);
        el.textContent = m[1] + (target * e).toFixed(dec) + m[3];
        if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
      }
      setTimeout(function () { requestAnimationFrame(step); }, 1100);
    });
  }

  /* ---------- Header: scroll state, drawer, search ---------- */
  function header(root) {
    $$('[data-mz-header]', root).forEach(function (h) {
      if (h.__mz) return; h.__mz = true;
      var scrim = h.querySelector('[data-mz-scrim]'), drawer = h.querySelector('[data-mz-drawer]'), search = h.querySelector('[data-mz-search]');
      var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 12); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      function close() {
        [drawer, search, scrim].forEach(function (n) { if (n) n.classList.remove('is-open'); });
        document.documentElement.style.overflow = '';
        $$('[aria-expanded="true"]', h).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
      function open(panel, btn) {
        close(); if (!panel) return;
        panel.classList.add('is-open'); if (scrim) scrim.classList.add('is-open');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        if (panel === drawer) document.documentElement.style.overflow = 'hidden';
        var f = panel.querySelector('input, a, button'); if (f) setTimeout(function () { f.focus(); }, 350);
      }
      h.addEventListener('click', function (e) {
        var t = e.target.closest('[data-mz-drawer-open],[data-mz-search-open],[data-mz-close]');
        if (!t) return;
        if (t.hasAttribute('data-mz-drawer-open')) open(drawer, t);
        else if (t.hasAttribute('data-mz-search-open')) open(search, t);
        else close();
      });
      if (scrim) scrim.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* ---------- Carousel (native scroll-snap + arrows + drag + progress) ---------- */
  function slider(root) {
    $$('[data-mz-slider]', root).forEach(function (el) {
      if (el.__mz) return; el.__mz = true;
      var track = el.querySelector('[data-track]'); if (!track) return;
      var prev = el.querySelector('[data-prev]'), next = el.querySelector('[data-next]'), bar = el.querySelector('[data-progress]');
      function step() {
        var c = track.children[0]; if (!c) return track.clientWidth;
        return c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var view = track.clientWidth / Math.max(track.scrollWidth, 1);
        var p = max > 0 ? track.scrollLeft / max : 1;
        if (bar) bar.style.setProperty('--p', (view + (1 - view) * p).toFixed(3));
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      // mouse drag
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
        if (moved) track.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false;
        if (moved) {
          var s = step(), target = Math.round(track.scrollLeft / s) * s;
          track.classList.remove('is-drag');
          track.scrollTo({ left: target, behavior: 'smooth' });
        }
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
      // optional autoplay
      var every = parseInt(el.getAttribute('data-autoplay') || '0', 10);
      if (every > 0 && !reduce && !designMode) {
        var timer, hover = false;
        el.addEventListener('mouseenter', function () { hover = true; });
        el.addEventListener('mouseleave', function () { hover = false; });
        timer = setInterval(function () {
          if (hover || document.hidden) return;
          var max = track.scrollWidth - track.clientWidth;
          track.scrollTo({ left: track.scrollLeft >= max - 4 ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
        }, every * 1000);
      }
    });
  }

  /* ---------- Countdown ---------- */
  function countdown(root) {
    $$('[data-mz-countdown]', root).forEach(function (el) {
      if (el.__mz) clearInterval(el.__mz);
      var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
      var end = Date.parse(raw);
      if (isNaN(end)) { el.hidden = true; return; }
      var nodes = {}; $$('[data-u]', el).forEach(function (n) { nodes[n.getAttribute('data-u')] = n; });
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function set(k, v) { var n = nodes[k]; if (!n) return; v = pad(v); if (n.textContent !== v) { n.textContent = v; n.classList.remove('is-tick'); void n.offsetWidth; n.classList.add('is-tick'); } }
      function tick() {
        var d = end - Date.now();
        if (d <= 0) { el.classList.add('is-ended'); clearInterval(el.__mz); return; }
        set('d', Math.floor(d / 864e5)); set('h', Math.floor(d / 36e5) % 24); set('m', Math.floor(d / 6e4) % 60); set('s', Math.floor(d / 1e3) % 60);
      }
      tick(); el.__mz = setInterval(tick, 1000);
    });
  }

  /* ---------- Copy discount code ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mz-copy]'); if (!b) return;
    var wrap = b.closest('.mz-code'), code = b.getAttribute('data-mz-copy');
    var done = function () { if (wrap) { wrap.classList.add('is-copied'); setTimeout(function () { wrap.classList.remove('is-copied'); }, 2200); } };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* ---------- Video modal ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mz-video]'); if (!b) return;
    var dlg = document.getElementById(b.getAttribute('data-mz-video')); if (!dlg || !dlg.showModal) return;
    e.preventDefault();
    var frame = dlg.querySelector('[data-frame]');
    frame.innerHTML = '<iframe src="' + b.getAttribute('data-src') + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Video"></iframe>';
    dlg.showModal();
    var shut = function () { dlg.close(); };
    dlg.querySelector('[data-mz-modal-close]').onclick = shut;
    dlg.onclick = function (ev) { if (ev.target === dlg) shut(); };
    dlg.onclose = function () { frame.innerHTML = ''; };
  });

  /* ---------- Scroll to next section ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mz-next]'); if (!b) return;
    var sec = b.closest('.shopify-section') || b.closest('section');
    var nxt = sec && sec.nextElementSibling;
    if (nxt) window.scrollTo({ top: nxt.getBoundingClientRect().top + window.scrollY - 80, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- Quick add (AJAX cart) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-mz-quick-add]'); if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button'); btn.classList.add('is-loading');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var finish = function (ok) {
      btn.classList.remove('is-loading');
      if (ok) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 2000); }
    };
    if (form.hasAttribute('data-demo')) { setTimeout(function () { finish(true); bump(); }, 600); return; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-mz-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
        finish(true); bump();
        document.dispatchEvent(new CustomEvent('modeza:cart-updated', { detail: cart }));
      })
      .catch(function () { finish(false); form.removeAttribute('data-mz-quick-add'); form.submit(); });
  });
  function bump() {
    $$('[data-mz-cart-count]').forEach(function (n) {
      if (n.hasAttribute('data-demo')) { n.textContent = (parseInt(n.textContent, 10) || 0) + 1; n.hidden = false; }
      n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump');
    });
  }

  /* ---------- Soft parallax ---------- */
  var px = [];
  function parallax(root) {
    if (reduce) return;
    $$('[data-mz-parallax]', root).forEach(function (el) { if (px.indexOf(el) < 0) px.push(el); });
  }
  var ticking = false;
  function runParallax() {
    ticking = false;
    if (window.innerWidth < 990) { px.forEach(function (el) { el.style.transform = ''; }); return; }
    px.forEach(function (el) {
      var r = el.getBoundingClientRect(), speed = parseFloat(el.getAttribute('data-mz-parallax')) || 0.1;
      if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
      el.style.transform = 'translate3d(0,' + (r.top * -speed).toFixed(1) + 'px,0)';
    });
  }
  window.addEventListener('scroll', function () { if (!ticking && px.length) { ticking = true; requestAnimationFrame(runParallax); } }, { passive: true });

  /* ---------- Boot ---------- */
  function init(root) { reveal(root); countUp(root); header(root); slider(root); countdown(root); parallax(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-track] > *');
    if (slide) slide.parentNode.scrollTo({ left: slide.offsetLeft - slide.parentNode.offsetLeft, behavior: 'smooth' });
  });
  window.Modeza = { init: init };
})();
